import { CSSProperties } from 'react'

const styles = {
  drawerContainer: {
    height: 70,
    paddingLeft: 3,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  drawerHeader: {
    fontWeight: 'bold',
    fontSize: 24
  } as CSSProperties,
  drawerSubheader: {
    fontWeight: 'bold',
    fontSize: 12
  } as CSSProperties,
  drawerTitle: {
    fontWeight: 'bold',
    fontSize: 16
  } as CSSProperties,
  drawerBoldText: {
    fontSize: 12,
    fontWeight: 'bold',
    paddingBottom: 5
  } as CSSProperties,
  drawerSubtitle: {
    fontSize: 12
  } as CSSProperties,
  bottomLine: {
    borderBottomWidth: 'thin',
    borderBottomStyle: 'solid',
    width: '100%'
  } as CSSProperties,
  closeIcon: {
    float: 'right',
  } as CSSProperties,
  subTitleContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    cursor: 'pointer'
  } as CSSProperties,
  edit: {
    display: 'flex',
    cursor: 'pointer',
    float: 'right',
    paddingRight: 32
  } as CSSProperties,
  deleteContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 90,
    position: 'absolute',
    zIndex: 100,
    backgroundColor: 'gray',
    opacity: 0.9,
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20
  } as CSSProperties,
  trash: {
    display: 'flex',
    flexDirection: 'row',
  } as CSSProperties,
  largeText: {
    fontSize: 20,
    fontWeight: 'bold'
  } as CSSProperties,
}

export default styles
